// Caja de cuotas sin interés de la ficha (snippets/cuotas-box.liquid).
// No calcula nada: al cambiar de variante toma la caja que Liquid ya renderizó
// para la variante nueva, así los tramos solo viven en snippets/cuotas-texto.liquid.
if (!customElements.get('fr-cuotas-box')) {
  customElements.define(
    'fr-cuotas-box',
    class FrCuotasBox extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.scope = this.productInfo || document;

        // 1) Evento de cambio de variante del tema (Dawn): trae el HTML de la sección con la variante nueva
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        }

        // 2) Respaldo: cambios en el input del id de variante (otras apps o selectores sin evento)
        this.onIdChange = (event) => {
          if (event.target?.name !== 'id') return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.refresh(event.target.value), 250);
        };
        this.scope.addEventListener('change', this.onIdChange);
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.scope?.removeEventListener('change', this.onIdChange);
        clearTimeout(this.timer);
      }

      get sectionId() {
        return this.productInfo?.sectionId || null;
      }

      onVariantChange(event) {
        const data = event?.data || {};
        if (this.productInfo && data.sectionId && data.sectionId !== this.sectionId) return;
        const nueva = data.html?.querySelector?.('fr-cuotas-box');
        if (nueva && nueva.dataset.productUrl === this.dataset.productUrl) this.swap(nueva);
      }

      async refresh(variantId) {
        if (!variantId || variantId === this.dataset.variantId) return;
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', variantId);
        if (this.sectionId) url.searchParams.set('section_id', this.sectionId);
        try {
          const response = await fetch(url.toString());
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nueva = html.querySelector('fr-cuotas-box');
          if (nueva && nueva.dataset.variantId === String(variantId)) this.swap(nueva);
        } catch (error) {
          console.warn('[cuotas] no se pudo actualizar la caja de cuotas', error);
        }
      }

      swap(nueva) {
        this.innerHTML = nueva.innerHTML;
        this.dataset.variantId = nueva.dataset.variantId;
      }
    }
  );
}
